import validator from 'validator'
import XRegExp from 'xregexp'

const addOn = {
	password: (str: string): boolean => {
		const regex = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,15}/
		return regex.test(str)
	},
	require: (str: string): boolean => {
		if (str !== 'undefined' && str !== null && str !== '') return true

		return false
	},
	noSpecial: (str: string): boolean => {
		const regex = /[&\/\\#,+()$~%.'":*?<>{}^!@|_=-]/
		return !regex.test(str)
	},
	isUserName: (str: string): boolean => {
		const regex = XRegExp('^[\\p{L}\\p{N}\\s]*$')
		return regex.test(str)
	},
	// removeSpecial: (str: string): string => {
	// 	return str.replace(/[&\/\\#,+()$~%.'":*?<>{}^!@|_=-]/gi, '')
	// },
	custom: (str: string, paramRegex: RegExp): boolean => {
		return paramRegex.test(str)
	},
}

export const rules: { [key: string]: any } = Object.assign(addOn, { ...validator })
